import { Grid, Box, Avatar, Card, CardActions, CardContent, Button, Typography } from '@mui/material';
import { useDashboardAdminQuery } from '../../service/apiSlices/accessApiService';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATION, getRandomColor, ROUTES } from '../../constants';
import { headerBreadcam } from '../../service/apiSlices/staticReducer';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
interface CardMediaProps {
    count: any;
    title: any;
    handleClick: any
}

function CardMedia(props: CardMediaProps) {
    const { count, title, handleClick } = props;
    // const backgroundColor = getColorFromLetter(title?.charAt(0));
    const backgroundColor = useMemo(() => getRandomColor(), [title]);
    return (
        <>
            <CardContent>
                <Avatar sx={{ m: 1, bgcolor: backgroundColor }}>
                    {title?.charAt(0)}
                </Avatar>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="h4">
                    {count}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={handleClick}>Learn More</Button>
            </CardActions>
        </>
    )
}


export default function Dashboard() {
    const { data: DashboardData } = useDashboardAdminQuery("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const navigateIssue = () => {
        dispatch(headerBreadcam('Manage Issue'))
        sessionStorage.setItem(AUTHENTICATION?.SHARED.PROFILE_HEADER, 'Manage Issue')
        navigate(ROUTES.MANAGEISSUE)
    }

    return (
        <Box sx={[{ width: '100%', mt: 4 }]}>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.assigned_issues} title={'Assigned Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid>
                <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.closed_issues} title={'Closed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid>
                <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.fixed_issues} title={'Fixed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid>
                {/* <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.not_assigned_issues} title={'Not Assigned Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid> */}
                {/* <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.not_closed_issues} title={'Not Closed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid> */}
                {/* <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.not_fixed_issues} title={'Not Fixed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid> */}
                {/* <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.not_viewed_issues} title={'Not Viewed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid> */}
                <Grid item xs={3}>
                    <Card variant="outlined">
                        <CardMedia count={DashboardData?.result?.data?.viewed_issues} title={'Viewed Issues'}
                            handleClick={navigateIssue} />
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
